import React from 'react'
import PageHeader from '../components/shared/pageHeader/PageHeader'
import LeadsCreateHeader from '../components/leads/TestDualResultHeader'
import LeadsCreateContent from '../components/leads/TestDualResultEdit'
import Footer from '../components/shared/Footer'

const CategoryTable = () => {
    return (
        <>
            <PageHeader>
  
            </PageHeader>

            <div className='main-content'>
                <div className='row'>
                    <LeadsCreateContent/>
                </div>
            </div>
            
        </>
    )
}

export default CategoryTable